module.exports = __webpack_public_path__ + "img/junior-english.9e857090.png";